import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./CommissioinFlow.css";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import iferntile from "../../../assets/images/iferntile.png";
import { formatNumberWithCommasAndDecimal } from "../../helper";
import CommissionService from "../../../service/commissionrepot/commissionreport";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CurrencyLatestSeperator from "../../helper/currencyLatestSeperator";

function CommissionFlow(props) {
  const curr = useSelector((state) => state.curr);
  const { t } = useTranslation();
  const history = useHistory();
  const dataItems = props?.data?.todayResponse;
  const [value, setValue] = React.useState("1");
  const [activeTab, setActiveTab] = useState("tab1");
  const [showDiv, setShowDiv] = useState(false); // State to control the visibility of the div

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const NavigateHandler = (item) => {
    if (
      item === "fastStartCommission" ||
      item === "teamSalesCommission" ||
      item === "groupSalesRebate" ||
      item === "retailProfitBonus" ||
      item === "totalIncome"
    ) {
      history.push({
        pathname: `/commissionReport`,
        state: {
          data: item === "totalIncome" ? "fastStartCommission" : item,
        },
      });
    } else if (item === "totalEncashment" || item === "availableBalance") {
      history.push({
        pathname: `/encashment`,
      });
    } else {
      console.log("item clicked 2", item);
    }
  };

  // if (!props.commissionFlow) {
  //   return <div>Loading...</div>;
  // }

  return (
    <div>
      {/* {console.log("props.commissionFlow", props.commissionFlow)} */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <h4 style={{ fontWeight: "bold" }}>Commission Flow</h4>
                {/* <Tab
                  style={{ fontWeight: "bold" }}
                  label="Commission Flow" value="3" /> */}
                <Tab label="⚫ today" value="1" />
                <Tab label="⚫ accumulated" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <div
                className="commissionFlow"
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "space-between",
                  alignItems: "stretch",
                  padding: "10px 10px 20px 10px",
                  height: "100%",
                }}
              >
                {props.todayResponse.map((item, index) => {
                  console.log("item text", item);
                  if (item.text == "totalSuspended") {
                    return (
                      <div
                        className="commissionTile"
                        style={{
                          flex: "1 1 auto",
                          background: "#e5eef0",
                          padding: "50px 10px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        key={index}
                        onClick={() => NavigateHandler(item.text)}
                      >
                        <div className="commissionImage">
                          <img
                            src={iferntile}
                            style={{
                              width: "90px",
                              height: "90px",
                              borderRadius: "100%",
                              backgroundColor: "green",
                            }}
                          />
                        </div>
                        <div
                          className="commissionText"
                          style={{ paddingTop: "15px" }}
                        >
                          <small>{t(`Common.${item.text}`)}</small>
                        </div>
                        <div style={{ paddingTop: "15px" }}>
                          {item.tiles.map((suspended, key) => {
                            console.log("key goes here", suspended);
                            return (
                              <div key={key}>
                                <strong key="{key}">
                                  {suspended.title == "ilifestyle"
                                    ? ""
                                    : curr.currentCurr}
                                  {/* {suspended.amount} */}
                                  {CurrencyLatestSeperator(
                                    suspended.amount * curr.value,
                                    curr.precision
                                  )}
                                </strong>
                                <br />
                                <strong>
                                  {t(`Common.${suspended.title}`)}
                                </strong>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="commissionTile"
                        style={{
                          flex: "1 1 auto",
                          background: "#e5eef0",
                          padding: "50px 10px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        key={index}
                        onClick={() => NavigateHandler(item.text)}
                      >
                        <div className="commissionImage">
                          <img
                            src={iferntile}
                            style={{
                              width: "90px",
                              height: "90px",
                              borderRadius: "100%",
                              backgroundColor: "green",
                            }}
                          />
                        </div>
                        <div
                          className="commissionText"
                          style={{ paddingTop: "15px" }}
                        >
                          <small>{t(`Common.${item.text}`)}</small>
                        </div>
                        <div style={{ paddingTop: "15px" }}>
                          <strong>
                            {/* {curr.currentCurr}
                            {item.amount} */}
                            {curr.currentCurr}
                            {/* {dataItems && dataItems[index]} */}
                            {dataItems &&
                              CurrencyLatestSeperator(
                                dataItems[index] * curr.value,
                                curr.precision
                              )}
                          </strong>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </TabPanel>

            <TabPanel value="2">
              <div
                className="commissionFlow"
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "space-between",
                  alignItems: "stretch",
                  padding: "10px 10px 20px 10px",
                  height: "100%",
                }}
              >
                {props?.accumulatedResponse?.map((item, index) => {
                  if (item.text == "totalSuspended") {
                    return (
                      <div
                        className="commissionTile"
                        style={{
                          flex: "1 1 auto",
                          background: "#e5eef0",
                          padding: "50px 10px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        key={index}
                        onClick={() => NavigateHandler(item.text)}
                      >
                        <div className="commissionImage">
                          <img
                            src={iferntile}
                            style={{
                              width: "90px",
                              height: "90px",
                              borderRadius: "100%",
                              backgroundColor: "green",
                            }}
                          />
                        </div>
                        <div
                          className="commissionText"
                          style={{ paddingTop: "15px" }}
                        >
                          <small>{t(`Common.${item.text}`)}</small>
                        </div>
                        <div style={{ paddingTop: "15px" }}>
                          {item.tiles.map((suspended, key) => {
                            return (
                              <div key={key}>
                                <strong key="{key}">
                                  {/* {curr.currentCurr} */}

                                  {suspended.title == "ilifestyle"
                                    ? ""
                                    : curr.currentCurr}
                                  {/* {suspended.amount}
                                   */}
                                  {CurrencyLatestSeperator(
                                    suspended.amount * curr.value,
                                    curr.precision
                                  )}
                                </strong>
                                <br />
                                <strong>
                                  {t(`Common.${suspended.title}`)}
                                </strong>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="commissionTile"
                        style={{
                          flex: "1 1 auto",
                          background: "#e5eef0",
                          padding: "50px 10px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        key={index}
                        onClick={() => NavigateHandler(item.text)}
                      >
                        <div className="commissionImage">
                          <img
                            src={iferntile}
                            style={{
                              width: "90px",
                              height: "90px",
                              borderRadius: "100%",
                              backgroundColor: "green",
                            }}
                          />
                        </div>
                        <div
                          className="commissionText"
                          style={{ paddingTop: "15px" }}
                        >
                          <small>{t(`Common.${item.text}`)}</small>
                        </div>
                        <div style={{ paddingTop: "15px" }}>
                          <strong>
                            {/* {curr.currentCurr}
                            {dataItems && dataItems[index]} */}
                            {curr.currentCurr}
                            {/* {item.amount} */}
                            {CurrencyLatestSeperator(
                              item.amount * curr.value,
                              curr.precision
                            )}
                          </strong>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </div>
  );
}

export default CommissionFlow;
